__turbopack_context__.v({
  "headline": "WybBdG_headline",
  "l": "WybBdG_l",
  "label": "WybBdG_label",
  "m": "WybBdG_m",
  "s": "WybBdG_s",
  "text": "WybBdG_text",
  "title": "WybBdG_title",
  "truncate": "WybBdG_truncate",
  "underline": "WybBdG_underline",
  "xl": "WybBdG_xl",
  "xs": "WybBdG_xs",
});
